import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import Showcase from '../components/Showcase';
import Social from '../components/Social';
import Enterprise from '../components/Enterprise';
import BackgroundPattern from '../components/BackgroundPattern';

export default function Landing() {
  return (
    <div className="relative">
      {/* Subtle ambient pattern only over hero */}
      <div className="relative">
        <BackgroundPattern />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/40 to-white pointer-events-none" />
        <Navbar />
        <div className="relative">
          <Hero />
        </div>
      </div>
      <Features />
      <Social />
      <Showcase limit={4} />
      <Pricing />
      <Enterprise />
      <FAQ />
      <Footer />
    </div>
  );
}
